import { generatePath } from 'react-resource-router';

import {
	autoDevAssemblyLinePath,
	autoDevRefineIssuePath,
	boysenberryCodePagePath,
	boysenberryFlowPath,
	environmentSettingsPath,
	reviewerRepositoriesPath,
	standardsDetailPath,
} from './paths';

export const getStandardFileName = (name: string): string =>
	name.trim().replace(/\s+/g, '-').toLowerCase();

export const getStandardsDetailPath = (standardId: string): string =>
	generatePath(standardsDetailPath, { standardId });

export const createFlowRoute = (flowId: string) => {
	return generatePath(boysenberryFlowPath, {
		flowId,
	});
};

export const createFlowCodeRoute = (flowId: string) => {
	return generatePath(boysenberryCodePagePath, {
		flowId,
	});
};

export const createAutoDevRefineRoute = (issueKey: string) => {
	return generatePath(autoDevRefineIssuePath, {
		issueKey,
	});
};

export const createAutoDevAssemblyLineRoute = (workstreamId: string) => {
	return generatePath(autoDevAssemblyLinePath, {
		workstreamId,
	});
};

export const encodeRepositoryUrl = (repositoryUrl: string): string => {
	return btoa(repositoryUrl);
};

export const createEnvironmentSettingsRoute = (repositoryUrl: string) => {
	const encodedRepoUrl = encodeRepositoryUrl(repositoryUrl);
	return generatePath(environmentSettingsPath, {
		encodedRepoUrl,
	});
};

export const decodeRepositoryUrl = (encodedRepoUrl: string): string => {
	return atob(encodedRepoUrl);
};

export const getReviewerRepositoryUrl = (repoAri: string): string =>
	`${reviewerRepositoriesPath}?repoAri=${encodeURIComponent(repoAri)}`;
